import React from "react";
import loader from "../../assets/icons/loader.gif";

interface IProps {
  description: string;
}

const InlineLoader = ({ description }: IProps) => {
  return (
    <div className="cds--inline-loading">
      <img src={loader} alt="Loading..." />
      <div className="cds--inline-loading__text">{description}</div>
    </div>
  );
};

export default InlineLoader;
